import React from "react";
import {Checkbox} from "spectre-react/dist/cjs";
import cx from "classnames";


const SelectionModeNotificationBlock = ({wrapperClassName, onTextClick, onSwitchClick, isEnabled}) => {
    return (
        <div className={cx("d-flex flex-centered", wrapperClassName)}>
            <div className="c-hand text-bold text-uppercase text-hover-underline" onClick={onTextClick}>
                Включен режим подбора коэффициентов
            </div>
            <Checkbox switch large
                      className="my-0 ml-4"
                      onChange={onSwitchClick}
                      checked={isEnabled}
            />
        </div>
    )
}


export default SelectionModeNotificationBlock;